export class Tache {
    idtache: number;
    libelletache: string;
    dateDebut: string;
    dateFin: string;
    dateAffectation: string;
    dateDebutTraitement: string;
    dateFinTraitement: string;
    dateAbandon: string;
    dateAnnulation: string;
    dateValidation: string;
    dateConfirmation: string;
    dateRejet: string;
    etat: number;
    commentaire: string;
    idtachelie: string;
    dependance: string;
    societe: string;
    idprojet: number;
    idetape: number;
    iduser: number;
    idrencontre: string;
    usercreation: number;
    datecreation: string;
    supprimer: string;
    efficacite: string;
    observations: string;
    idsourcetache: string;
    old_state: string;
    new_state: string;
    user_state: number;
    date_state: string;
    executant: number;
    idprofil: number;
}



// WEBPACK FOOTER //
// /Users/numherit/PhpstormProjects/TEMPLATES/sunuprojet/src/app/models/tache.ts